import React from 'react';

/** Interruptor accesible (role="switch"). size: 'md' | 'sm'. */
export default function Switch({ checked, onChange, disabled = false, label, size = 'md', id }) {
  const dims = size === 'sm' ? { w: 30, h: 17, k: 13 } : { w: 38, h: 22, k: 16 };
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => !disabled && onChange(!checked)}
      className="relative flex-shrink-0 rounded-full transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#00C2FF] focus-visible:ring-offset-2 focus-visible:ring-offset-[#12132a]"
      style={{
        width: dims.w, height: dims.h,
        backgroundColor: checked ? '#22C55E' : 'rgba(255,255,255,0.10)',
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      <span
        className="absolute top-1/2 rounded-full bg-white transition-transform duration-150 motion-reduce:transition-none"
        style={{
          width: dims.k, height: dims.k, left: 3,
          transform: `translate(${checked ? dims.w - dims.k - 6 : 0}px, -50%)`,
          boxShadow: '0 1px 2px rgba(0,0,0,0.4)',
        }}
      />
    </button>
  );
}
